import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { Draggable } from 'react-beautiful-dnd'

class StageplanSidebarItem extends Component {
  constructor(props) {
    super(props)

    this.item = React.createRef()
  }

  render() {
    const { item, itemIndex, parentItemIndex, existingItem, fontSize, hideAnimation } = this.props

    const className = (snapshot) => classnames({
      'stageplan-sidebar-item': true,
      'stageplan-sidebar-item--disabled': existingItem,
      'stageplan-sidebar-item--hidden': snapshot.isDragging && hideAnimation
    })

    return (
      <Draggable draggableId={!isNaN(parentItemIndex) ? `${parentItemIndex}-${itemIndex}` : itemIndex} isDragDisabled={existingItem} type="stageplan">
        {(provided, snapshot) => (
          <li ref={provided.innerRef}>
            <div className={className(snapshot)} style={provided.draggableStyle}>
              <div className="stageplan-item" ref={this.item}
                style={{
                  fontSize,
                  padding: `${fontSize*0.5}px ${fontSize*1.5}px`
                }}
                onMouseEnter={() => {
                  if (existingItem) this.props.setRiderStageplanItemFocus(existingItem)
                }}
                onMouseLeave={() => this.props.setRiderStageplanItemFocus(undefined)}
                onMouseMove={(e) => {
                  if (!existingItem) {
                    const clientRect = ReactDOM.findDOMNode(this.item.current).getBoundingClientRect()
                    const { width, height } = clientRect

                    const x = e.nativeEvent.offsetX
                    const y = e.nativeEvent.offsetY

                    this.props.setDragStartOffset({
                      width,
                      height,
                      x: (width/2)-x,
                      y: (height/2)-y
                    })
                  }
                }}
                onDoubleClick={(e) => {
                  if (!existingItem) this.props.createRiderStageplanItem(item)
                }}
                {...provided.dragHandleProps}>
                {
                  item.channel
                  ? <span className="channel" style={{fontSize: fontSize*1.1}}>{item.channel}</span>
                  : null
                }

                {item.value || item.title || item.name}
              </div>
            </div>

            {provided.placeholder}
          </li>
        )}
      </Draggable>
    )
  }
}

StageplanSidebarItem.propTypes = {
  item: PropTypes.object,
  itemIndex: PropTypes.number,
  parentItemIndex: PropTypes.number,
  existingItem: PropTypes.string,
  fontSize: PropTypes.number,
  hideAnimation: PropTypes.bool,
  setDragStartOffset: PropTypes.func,
  setRiderStageplanItemFocus: PropTypes.func,
  createRiderStageplanItem: PropTypes.func
}

StageplanSidebarItem.defaultProps = {
  item: {},
  itemIndex: undefined,
  parentItemIndex: undefined,
  existingItem: undefined,
  fontSize: 12,
  hideAnimation: false,
  setDragStartOffset: function() {},
  setRiderStageplanItemFocus: function() {},
  createRiderStageplanItem: function() {}
}

export default StageplanSidebarItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplan-sidebar-item.js